import React, { FunctionComponent, ChangeEvent } from "react";
import { Choice, Alert } from "@cmsgov/ds-medicare-gov";
import { useTranslate } from "../../helpers";
import { FormattedMessage } from "react-intl";
import { choiceIdMap } from "./constants";
import { CoverageSelectorCoverageType } from "../../@types";

export const getCoverageTypeLabel = (
  coverageType: CoverageSelectorCoverageType
): string | undefined | null => {
  let description = undefined;
  if (coverageType) {
    const choiceId = choiceIdMap[coverageType];
    const labelKey = `label[for='${choiceId}']`;
    description = document.querySelector(labelKey)?.textContent;
  }
  return description;
};

interface PlanQuestionsProps {
  handleChoice: (e: ChangeEvent<HTMLInputElement>) => void;
  coverageSelection?: CoverageSelectorCoverageType;
}

// Modeled after src/pages/QuestionRoutingPage/PlanQuestions.tsx
// TODO: see if we can combine the two.
export const PlanQuestions: FunctionComponent<PlanQuestionsProps> = ({
  handleChoice,
  coverageSelection,
}) => {
  const t = useTranslate();

  const mapdSelected = coverageSelection === CoverageSelectorCoverageType.MAPD;
  const pdpSelected = coverageSelection === CoverageSelectorCoverageType.PDP;
  const medigapSelected =
    coverageSelection === CoverageSelectorCoverageType.MedigapPolicy;

  return (
    <>
      <Choice
        type="radio"
        name="what-coverage"
        id={choiceIdMap[CoverageSelectorCoverageType.MAPD]}
        data-testid={choiceIdMap[CoverageSelectorCoverageType.MAPD]}
        value={CoverageSelectorCoverageType.MAPD}
        onChange={handleChoice}
        checked={mapdSelected}
        checkedChildren={
          <Alert role="alert" hideIcon={true}>
            {t("landing_page.coverage_selection.mapd.text")}
          </Alert>
        }
        label={t("landing_page.coverage_selection.mapd.heading")}
      />

      <Choice
        type="radio"
        name="what-coverage"
        id={choiceIdMap[CoverageSelectorCoverageType.PDP]}
        data-testid={choiceIdMap[CoverageSelectorCoverageType.PDP]}
        value={CoverageSelectorCoverageType.PDP}
        onChange={handleChoice}
        checked={pdpSelected}
        checkedChildren={
          <Alert role="alert" hideIcon={true}>
            {t("landing_page.coverage_selection.pdp.text")}
          </Alert>
        }
        label={
          <FormattedMessage
            id="landing_page.coverage_selection.pdp.heading"
            tagName="span"
            values={{
              message: <span aria-label="Dee">D</span>,
            }}
          />
        }
      />

      <Choice
        type="radio"
        name="what-coverage"
        id={choiceIdMap[CoverageSelectorCoverageType.MedigapPolicy]}
        data-testid={choiceIdMap[CoverageSelectorCoverageType.MedigapPolicy]}
        value={CoverageSelectorCoverageType.MedigapPolicy}
        onChange={handleChoice}
        checked={medigapSelected}
        checkedChildren={
          <>
            <Alert role="alert" hideIcon={true}>
              {t("landing_page.coverage_selection.medigap.text")}
            </Alert>
          </>
        }
        label={t("landing_page.coverage_selection.medigap.heading")}
      />
      <Choice
        id={choiceIdMap[CoverageSelectorCoverageType.learnMore]}
        data-testid={choiceIdMap[CoverageSelectorCoverageType.learnMore]}
        type="radio"
        name="what-coverage"
        value={CoverageSelectorCoverageType.learnMore}
        onChange={handleChoice}
        label={t("landing_page.learn_more.heading")}
      />
    </>
  );
};
